import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

// Inline issue tags shown after a title: Reopened (amber + refresh glyph) and
// DVIR origin (green — DVIR-sourced, NOT a safety call-out). The red "⚠ DVIR Not
// Safe" tag is intentionally absent — vehicle DVIR safety lives in the page
// header strip.
@Component({
  selector: 'app-issue-tags',
  templateUrl: './issue-tags.component.html',
  styleUrls: ['./issue-tags.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IssueTagsComponent {
  @Input() reopened = false;
  @Input() dvirOrigin = false;
}
